<!--重要事件-->
<template>
	<div class="mod clearfix mod-important">
	    <h2 id="miao"><i>12</i>重要事件</h2>
	    <div class="block-bg">
	        <h3>{{time}}&nbsp;&nbsp;&nbsp;{{title}}<span class="fr">{{date}}</span></h3>
	        <p>{{content}}</p>
	        <div  class="important-stocks">
              <div v-html="zysj"></div>
	        
	        </div>
	    </div>
	</div>
</template>
<script>
export default {
  data() {
    return {
      date: null,
      time: null,
      content: null,
      title: null,
      fulldate: null,
      items: null,
      zysj: null
    };
  },
  mounted: function() {
    this.getFirstMsg();
  },
  methods: {
    fmtStr(obj){
      var str = "'VIEWSTOCK?DATATYPE=DAY&LABEL="+obj+"&PAGE=分时走势;VIEWINDI?NUMPIC=3&INDI1=MA&INDI2=VOL;INDI3=SVNS'";
      return str;
    },
    getFirstMsg() {
      let self = this;
      dzhyun
        .query(
          "/event/news",
          {
            sort: "desc",
            start: -1,
            count: 1
          },
          resStockList => {
            this.items = resStockList[0].objList;
            this.content = resStockList[0].context;
            this.fulldate = resStockList[0].date.trim().split(/\s+/);
            this.time = this.fulldate[1];
            this.date = this.fulldate[0];
          }
        )
        .then(function(data) {
          dzhyun.subscribe(
            "/stkdata",
            {
              obj: data[0].objList,
              field: "ZhongWenJianCheng,ZhangFu",
              mode: 2
            },
            data => {
              var html = "";
              data.forEach(item => {
                if (item.ZhangFu > 0) {
                  html +=
                    '<a href="javascript:void(0);" onclick="window.external.addcommand('+self.fmtStr(item.Obj)+')" class="red">' +
                    item.Obj.slice(2) +
                    "&nbsp;&nbsp;&nbsp;" +
                    item.ZhongWenJianCheng +
                    "<b>+" +
                    item.ZhangFu +
                    "%</b></a>";
                } else if (item.ZhangFu == 0) {
                  html +=
                    '<a href="javascript:void(0);" onclick="window.external.addcommand('+self.fmtStr(item.Obj)+')" >' +
                    item.Obj.slice(2) +
                    "&nbsp;&nbsp;&nbsp;" +
                    item.ZhongWenJianCheng +
                    "<b>" +
                    item.ZhangFu +
                    "%</b></a>";
                } else if (item.ZhangFu < 0) {
                  html +=
                    '<a href="javascript:void(0);" onclick="window.external.addcommand('+self.fmtStr(item.Obj)+')" class="green">' +
                    item.Obj.slice(2) +
                    "&nbsp;&nbsp;&nbsp;" +
                    item.ZhongWenJianCheng +
                    "<b>" +
                    item.ZhangFu +
                    "%</b></a>";
                }
              });
              self.zysj = html;
            }
          );
        });
    },
    getHangQing() {
      dzhyun.subscribe(
        "/stkdata",
        {
          obj: "SH601011,SH600691,SH600256,SH600123",
          field: "ZhongWenJianCheng,ZhangFu"
        },
        data => {
          let _res = [];
        }
      );
    },
    format(fmt) {}
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/home/components/zysj.vue